<div class="wrapper" [ngStyle]="{'width':sizePx(),'height':sizePx(),'border-radius':radius()}">
  <img #image />
</div>
@if(url$ | async){ }
